// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import 'whatwg-fetch';
import "babel-polyfill";
import Vue from './lib/Vue';
import App from './App';
import router from './router';
import store from './store';


Vue.config.productionTip = false;

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  template: '<App/>',
  components: { App },
});



// WEBPACK FOOTER //
// ./src/main.js